import FileUploadErrorType from '../enums/FileUploadErrorType';
const STATUS_TO_UPLOAD_ERROR_TYPE = {
  413: FileUploadErrorType.FILE_TOO_LARGE,
  403: FileUploadErrorType.MISSING_WRITE_SCOPE
};
function isFileUploadErrorType(errorType) {
  return errorType && errorType in FileUploadErrorType;
}
export const getUploadErrorType = err => {
  if (err.responseJSON) {
    const json = err.responseJSON;
    if (isFileUploadErrorType(json.errorType)) {
      return json.errorType;
    } else if (isFileUploadErrorType(json.message)) {
      return json.message;
    }
  }
  return STATUS_TO_UPLOAD_ERROR_TYPE[err.status] || null;
};